export const NewsSection = () => {
  return (
    <div id="newsSectionContainer">
      <div className="sectionHeader">News</div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "70%",
        }}
      >
        <div>
          <p>Link Number 1</p>
          <div>IMAGE</div>
        </div>
        <div>
          <p>Link Number 2</p>
          <div>IMAGE</div>
        </div>
      </div>
    </div>
  );
};
